import { useMemo } from 'react';
import { useLogin } from '@SERVICES';
import { useAppDispatch, useAppSelector } from '@STORE/index';
import { EqualityFn } from 'react-redux';
import { authSlice, AuthState } from '@REDUCERS';

function createAuthHook() {
    return function useAuth(equalityFn?: EqualityFn<AuthState>) {
        const [login, loginData] = useLogin({
            fixedCacheKey: 'login',
        });

        const { user, permissions } = useAppSelector((store) => store.auth, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            logout: () => dispatch(authSlice.actions.logout()),
        }), [dispatch]);

        return {
            actions: {
                login,
                logout: actions.logout,
            },
            state: {
                user,
                permissions,
                loginData,
            },
        };
    };
}

export default createAuthHook();
